// extracted by mini-css-extract-plugin
module.exports = {"youtubeContainer":"youtube-video-module--youtube-container--3AJeG"};